import { RegisteredComponent } from "@builder.io/sdk-react";
import { THEME_FIELD } from "../commonFields";

export const sectionBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Core:Section",
  override: true,
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      layerName: "Container",
      responsiveStyles: {
        large: {
          paddingLeft: "var(--spacing-6, 24px)",
          paddingRight: "var(--spacing-6, 24px)",
          paddingTop: "var(--spacing-16, 64px)",
          paddingBottom: "var(--spacing-16, 64px)",
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: "1280px",
          width: "100%",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        },
        xsmall: {
          paddingTop: "var(--spacing-12, 48px)",
          paddingBottom: "var(--spacing-12, 48px)",
        },
      },
    },
  ],
  canHaveChildren: true,
  inputs: [THEME_FIELD],
};
